import MuiAccordion from '@material-ui/core/Accordion';
import { withStyles } from '@material-ui/core';

export const Accordion = withStyles({
  root: {
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderRadius: '15px !important',
    '&:not(:last-child)': {
      marginBottom: '15px',
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      backgroundColor: '#e5f7f7',
      margin: '15px 0',
    },
  },
  expanded: {},
})(MuiAccordion);
